
<div :id="content.idHTML" class="px-0 py-0">
  <ValidationObserver ref="observer" v-slot="{ invalid }" :vid="'vobserver' + uniqueId" tag="div">
    <b-form :id="'idFormulaire' + uniqueId" @submit.stop.prevent="onSubmit($event)">
      <!-- Title  -->
      <Titre
        :content="{
          titre: title,
          type: 'titre pt-0 pb-1',
        }"
        :class="['title-secondary', { 'title-option': category !== 'deposit' }]"
      ></Titre>
      <!-- Description -->
      <Paragraphe
        :content="{
          richText: texte,
          classeCSS: 'pb-1',
        }"
        class="texte-desc"
      ></Paragraphe>
      <Hyperlien v-if="contentAide" :content="contentAide" class="mt-n1 mb-2 fs-1" />
      <!-- If submit chosen limit is success -->
      <div v-if="!isSuccess" class="input-btn-group">
        <GroupeRadioDepot
          v-model="choix"
          :cat="category"
          :content="contentGroupeRadio"
          @input="setLimitValue"
        ></GroupeRadioDepot>
        <!-- Message erreur d'envoi -->
        <div v-show="isErreurServeur" class="error-depot">
          <MessageMel
            v-show="contentMessageMel.message"
            :content="contentMessageMel.message"
            class="mt-n1 mt-md-0 mx-0 pl-0 d-flex justify-content-end"
          ></MessageMel>
        </div>
        <!-- Bouton Confirmer -->
        <div v-show="showConfirmBtn" class="btn-right">
          <button
            type="submit"
            class="btn btn-confirm px-6 mb-0"
            tabindex="0"
            :disabled="invalid || isSubmitted"
            @click="confirmChoice"
          >
            <div class="load-spinner">
              <div v-if="isSubmitted" class="mr-1">
                <b-spinner small :label="$t('chargement')"></b-spinner>
              </div>
              <span class="btn-text">{{ content.libBtnConfirmer }}</span>
            </div>
          </button>
        </div>
      </div>
      <!-- Show actual limit chosen -->
      <div v-show="isSuccess" class="actual-limit">
        <span>{{ getTextLocalised(choix) }}</span>
      </div>
    </b-form>
  </ValidationObserver>
</div>
